import React from 'react';
import { Box } from '@material-ui/core';
import Form from './Form';
import config from '../../preorder/configs/config';

export default ({
  afterLoginUrl,
  isConnectPhone,
  isFinishRegister,
  isMgm,
  onAuthButtonClick,
  onConnectLineClick,
  onLoginClick,
  onNextButtonClick,
  onProfileNextButtonClick,
}) => (
  <Box
    display="flex"
    alignItems={{ sm: 'center' }}
    flexDirection={{ xs: 'column', sm: 'row' }}
    height="100%"
    width={1}
    maxWidth={800}
    boxSizing="borderBox"
  >
    <Box
      color="white"
      flexShrink={0}
      fontSize={40}
      fontWeight="bold"
      ml={{ xs: 5, sm: 0 }}
      mt={{ xs: 5, sm: 0 }}
    >
      <Box>{config.slogan1 || ''}</Box>
      <Box>{config.slogan2 || ''}</Box>
    </Box>
    <Box flexGrow={1} />
    <Box
      mt={{ xs: 4, sm: 0 }}
      width={{ xs: 1, sm: 372 }}
      flexShrink={0}
    >
      <Form
        afterLoginUrl={afterLoginUrl}
        isConnectPhone={isConnectPhone}
        isFinishRegister={isFinishRegister}
        isMgm={isMgm}
        onAuthButtonClick={onAuthButtonClick}
        onConnectLineClick={onConnectLineClick}
        onLoginClick={onLoginClick}
        onNextButtonClick={onNextButtonClick}
        onProfileNextButtonClick={onProfileNextButtonClick}
      />
    </Box>
  </Box>
);
